<template>
	<div class="main-container">
		<div v-if="this.createdRepository == null" class="create_container">
			<h2>Create new project</h2>
			<form @submit.prevent="submitForm()">
				<label>BBC's client Name</label>
				<div class="form-group form-group__project-name">
					<input type="text" class="form-control project-name" v-model="formData.clientName">
				</div>
				<label>Client's project name</label>
				<div class="form-group form-group__project-name">
					<input type="text" class="form-control project-name" v-model="formData.projectName">
				</div>
				<label>Project template</label>
				<div class="form-group">
					<select v-model="formData.template">
							<option
								v-for="(template, index) in templates"
								:value="template['branchName']"
								:key="index">
								{{ template['displayName'] }}
							</option>
					</select>
				</div> 
				
				<button type="submit" class="btn">create</button>
				<span v-if="!isCreating" class="validation">{{this.formValidaton.message}}</span>
				<img v-if="isCreating" src="~@/assets/images/gradient_load.gif" class="preloader">
			</form>
		</div>
		<div v-if="this.createdRepository != null">
			<h2>The project is being created created</h2>
			<p>An email notification will be issued when the project has sucessfully been created. This should be ready in a minute or so.</p>
			<p>Here's what the details will be:</p>
			<h4>CMS:</h4>
			<p><strong>URL:</strong>{{this.createdRepository.cms.url}}</p>
			<h4>GIT Repository:</h4>
			<p><strong>URL:</strong>{{this.createdRepository.git.cloneUrl}}</p>
			<h4>Preview links:</h4>
			<p>These urls will up to date with the latest commit for each of these branches:</p>
			<p><strong>dev:</strong><br>{{this.createdRepository.review.dev.url}}</p>
			<p><strong>test:</strong><br>{{this.createdRepository.review.test.url}}</p>
			<p><strong>master (should contain the live version):</strong><br>{{this.createdRepository.review.master.url}}</p>
		</div>
	</div>
</template>

<script>

	import api from '@/utils/api';
	import { AUTH_SERVICE_ERROR } from '@/store/actions/auth'

	export default {
		name: 'create',

		data () {
			return {
				formData:{
					projectName:'',
					clientName:'',
					template:''
				},
				formValidaton:{
					projectName:null,
					clientName:null,
					template:null,
					message:""
				},
				createdRepository:null,
				isCreating:false,
				templates:[]
			}
		},

		beforeMount(){

			let url = "get-templates"
			let self = this
			api({ url: url  })
			.then(response =>  {
				self.templates = response.data;
			})
			.catch(error => {
				if(error.response.status == 401 || error.response.status == 403){
					this.$store.dispatch(AUTH_SERVICE_ERROR, error);
				}
			});

		},

		methods: {

			submitForm(){

				this.formValidaton.message = ""

				if(this.validateSubmission(this.formData)){
					let projectName = this.formatStringsForNaming(this.formData.projectName);
					let clientName = this.formatStringsForNaming(this.formData.clientName)
					let newRepositoryName = "bdm-"+clientName+"-"+projectName
					
					let postData = {
						newRepositoryName: newRepositoryName.toLowerCase(),
						repositoryBranchTemplate: this.formData.template
					}
					this.createProject(postData)
				}
			},

			validateSubmission(entries){

				this.formValidaton.message = ""

				if(entries.projectName === ''){
					this.formValidaton.projectName = false
					this.addValidationMessage("project name is empty")
				}else{
					this.formValidaton.projectName = true
				}
				if(entries.clientName === ''){
					this.formValidaton.clientName = false
					this.addValidationMessage("client name is empty")
				}else{
					this.formValidaton.clientName = true
				}
				if(entries.template === ''){
					this.formValidaton.template = false
					this.addValidationMessage("please select a template")
				}else{
					this.formValidaton.template = true
				}
				if(this.formValidaton.message !== ''){
					this.formValidaton.message += ".  Please correct this and try again"
				}
				for (const [value] of Object.entries(this.formValidaton)) {
					if(value === false){
						return false
					}
				}
				return true
			},

			addValidationMessage(message){
				if(this.formValidaton.message !== ""){
					this.formValidaton.message += ", "
				}
				this.formValidaton.message += message
			},

			createProject(postData){
				let self = this

				self.isCreating = true;

				api({url: "create-project", data:  postData, method: 'POST' })

				.then(response =>  {
					self.isCreating = false;
					if(response.data.statusCode == 400){

						this.formValidaton.message = "Project already exists"

					}else{
						this.createdRepository = response.data
					}

				})

				.catch(() => {
					self.isCreating = false
				});

			},

			formatStringsForNaming(rawString){

				let interestedCharacters = rawString.replace(/(?!\w)(?! )(?!-)./g, "")
				interestedCharacters = interestedCharacters.replace(/ /g, "-")

				if(interestedCharacters.slice(-1) == "-"){
					interestedCharacters = interestedCharacters.substring(0, interestedCharacters.length - 1);
				}

				return interestedCharacters

			}

		}
	}

</script>

<style lang="scss" scoped>

	@import '@/scss/style.scss';

	.error_message {
		margin-top: 15px;
	}
	.main-container{
		position: relative;
		min-height: 100vh;
		padding: 30px;
		margin: 0 auto;
		width: 100%;
		max-width: 800px;
	}
	.form-group{
		&__project-name{
			display: flex;
		}
	}
	.project-name{
		flex: 1;
	}
	.prefix-name{
		display:inline-block;
		width: auto;
	}
	.create_container{
		width: 100%;
	}
	.validation{
		padding-top: 10px;
		padding-bottom: 10px;
		color:red;
		display: inline-block;
		vertical-align: middle;
		max-width: 600px;
	}
	.btn{
		vertical-align:middle;
		margin-right: 15px;
	}

</style>